<template>
  <header class="site-header">
    <div class="header-inner">
      <router-link class="home-mark" to="/" aria-label="KomeiC 首页"
        ><i><span></span><span></span><span></span></i><b>KomeiC</b></router-link>
      <nav>
        <router-link v-if="isAdmin" to="/admin">管理</router-link
        ><button
          v-if="!loginUser?.id"
          class="nav-btn"
          type="button"
          @click="openAuth()"
          >登录</button
        ><router-link v-else to="/account">我的</router-link
        ><router-link class="create" to="/space/create"
          ><icon-plus /><span>创建</span></router-link
        >
      </nav>
    </div>
  </header>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { IconPlus } from "@arco-design/web-vue/es/icon";
import { useLoginUserStore } from "@/store/userStore";
import { useAuthModal } from "@/composables/useAuthModal";
const store = useLoginUserStore(),
  { loginUser } = storeToRefs(store),
  isAdmin = computed(() =>
    ["admin", "super_admin"].includes(loginUser.value?.userRole || "")
  ),
  { show: openAuth } = useAuthModal();
</script>
<style scoped>
.site-header {
  position: fixed;
  inset: 0 0 auto;
  z-index: 80;
  height: var(--km-header);
  background: var(--km-header-bg);
  box-shadow: inset 0 -1px 0 rgba(228, 237, 244, 0.07);
  backdrop-filter: blur(10px);
}
.site-header::after {
  content: "";
  position: absolute;
  left: max(20px, calc((100% - var(--km-page)) / 2));
  right: max(20px, calc((100% - var(--km-page)) / 2));
  bottom: 0;
  height: 1px;
  background: var(--km-node-line);
  opacity: 0.24;
}
.header-inner {
  height: 100%;
  width: min(calc(100% - 40px), var(--km-page));
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.home-mark {
  min-width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color:#f4f5f6;
  text-decoration:none;
}
.home-mark i{width:38px;height:38px;display:flex;align-items:center;justify-content:center;gap:3px;font-style:normal}.home-mark b{font-size:14px;font-weight:650;letter-spacing:0}.home-mark span {
  width: 4px;
  border-radius: 4px;
  background: #dfe7ee;
}
.home-mark span:nth-child(1) {
  height: 10px;
  opacity: 0.45;
}
.home-mark span:nth-child(2) {
  height: 20px;
  background: #f2f4f6;
}
.home-mark span:nth-child(3) {
  height: 14px;
  background: #aeb7c0;
  opacity: 0.72;
}
nav {
  display: flex;
  align-items: center;
  gap: 24px;
}
nav a {
  position: relative;
  color: var(--km-muted);
  font-size: 13px;
  text-decoration: none;
}
nav a::after {
  content: "";
  position: absolute;
  left: 0;
  right: 100%;
  bottom: -8px;
  height: 1px;
  background: var(--km-node-line);
  transition: right 0.2s ease;
}
nav a:hover::after,
nav a.router-link-active::after {
  right: 0;
}
nav a:hover,
nav a.router-link-active,
.nav-btn:hover {
  color: var(--km-ink);
}
.nav-btn {
  border: 0;
  background: transparent;
  color: var(--km-muted);
  font-size: 13px;
  cursor: pointer;
}
nav .create {
  min-height: 36px;
  padding: 0 13px;
  display: flex;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 4px;
  background:
    linear-gradient(135deg, rgba(255,154,194,.14), rgba(189,128,255,.12) 52%, rgba(92,225,240,.13)),
    rgba(16,21,27,.42);
  color: #ffffff;
  box-shadow: inset 0 1px 0 rgba(242, 247, 252, 0.1);
}
@media (max-width: 720px) {
  .header-inner {
    width: calc(100% - 24px);
  }
  nav {
    gap: 12px;
  }
  nav .create {
    width: 38px;
    padding: 0;
    justify-content: center;
  }
  nav .create span {
    display: none;
  }
  .home-mark b{display:none}
}
</style>
